/**
 * Outer route guard: requires valid Autodesk token before rendering app routes.
 * If no token or expired, tries refresh once; on failure triggers loginWithAutodesk().
 */
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useAutodeskAuth } from "./AutodeskAuthContext";
import { hasValidAccessToken } from "./authService";

export default function AutodeskProtectedRoute() {
  const { isAuthenticated, isLoading, loginWithAutodesk, refreshAndUpdate, tokens } = useAutodeskAuth();
  const [triedRefresh, setTriedRefresh] = useState(false);

  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated) return;

    if (hasValidAccessToken()) return;

    if (tokens?.refresh_token && !triedRefresh) {
      setTriedRefresh(true);
      refreshAndUpdate().then((ok) => {
        if (!ok) loginWithAutodesk();
      });
      return;
    }

    loginWithAutodesk();
  }, [isLoading, isAuthenticated, triedRefresh, refreshAndUpdate, loginWithAutodesk, tokens]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-lg">Loading…</p>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Outlet />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-lg">Redirecting to sign in…</p>
    </div>
  );
}
